import { useMemo } from "react";
import { MAIN_MODULE_ACTION, useMainModuleDispatch } from "../../modules/main"
import P1 from "../../modules/main/game/scenario1/p1";
import P2 from "../../modules/main/game/scenario1/p2";
import P3 from "../../modules/main/game/scenario1/p3";
import P4 from "../../modules/main/game/scenario1/p4";
import P5 from "../../modules/main/game/scenario1/p5";
import P6 from "../../modules/main/game/scenario1/p6";
import P7 from "../../modules/main/game/scenario1/p7";
import P8 from "../../modules/main/game/scenario1/p8";
import P9 from "../../modules/main/game/scenario1/p9";
import P10 from "../../modules/main/game/scenario1/p10";
import P11 from "../../modules/main/game/scenario1/p11";
import P12 from "../../modules/main/game/scenario1/p12";
import P13 from "../../modules/main/game/scenario1/p13";
import P14 from "../../modules/main/game/scenario1/p14";
import P15 from "../../modules/main/game/scenario1/p15";
import P16 from "../../modules/main/game/scenario1/p16";
import P17 from "../../modules/main/game/scenario1/p17";
import P18 from "../../modules/main/game/scenario1/p18";
import P19 from "../../modules/main/game/scenario1/p19";
import P20 from "../../modules/main/game/scenario1/p20";
import P21 from "../../modules/main/game/scenario1/p21";
import P22 from "../../modules/main/game/scenario1/p22";
import P23 from "../../modules/main/game/scenario1/p23";
import P24 from "../../modules/main/game/scenario1/p24";
import P25 from "../../modules/main/game/scenario1/p25";
import P26 from "../../modules/main/game/scenario1/p26";
import P27 from "../../modules/main/game/scenario1/p27";
import P28 from "../../modules/main/game/scenario1/p28";
import P29 from "../../modules/main/game/scenario1/p29";
import P30 from "../../modules/main/game/scenario1/p30";
import P31 from "../../modules/main/game/scenario1/p31";
import P32 from "../../modules/main/game/scenario1/p32";
import P33 from "../../modules/main/game/scenario1/p33";
import P34 from "../../modules/main/game/scenario1/p34";
import P35 from "../../modules/main/game/scenario1/p35";
import P36 from "../../modules/main/game/scenario1/p36";
import P37 from "../../modules/main/game/scenario1/p37";
import P38 from "../../modules/main/game/scenario1/p38";
import P39 from "../../modules/main/game/scenario1/p39";
import P40 from "../../modules/main/game/scenario1/p40";
import P41 from "../../modules/main/game/scenario1/p41";
import P42 from "../../modules/main/game/scenario1/p42";    
import P43 from "../../modules/main/game/scenario1/p43";        
import P44 from "../../modules/main/game/scenario1/p44";
import P45 from "../../modules/main/game/scenario1/p45";    
import P46 from "../../modules/main/game/scenario1/p46";
import P47 from "../../modules/main/game/scenario1/p47";
import P48 from "../../modules/main/game/scenario1/p48";
import P49 from "../../modules/main/game/scenario1/p49";
import P50 from "../../modules/main/game/scenario1/p50";        
import P51 from "../../modules/main/game/scenario1/p51";
import P52 from "../../modules/main/game/scenario1/p52";
import P53 from "../../modules/main/game/scenario1/p53";
import P54 from "../../modules/main/game/scenario1/p54";        
import P55 from "../../modules/main/game/scenario1/p55";
import P56 from "../../modules/main/game/scenario1/p56";    
import P57 from "../../modules/main/game/scenario1/p57";    
import P58 from "../../modules/main/game/scenario1/p58";
import P59 from "../../modules/main/game/scenario1/p59";
import P60 from "../../modules/main/game/scenario1/p60";
import P61 from "../../modules/main/game/scenario1/p61";    
import P62 from "../../modules/main/game/scenario1/p62";    
import P63 from "../../modules/main/game/scenario1/p63";
import P64 from "../../modules/main/game/scenario1/p64";    
import P65 from "../../modules/main/game/scenario1/p65";
import P66 from "../../modules/main/game/scenario1/p66";
import P67 from "../../modules/main/game/scenario1/p67";
import P68 from "../../modules/main/game/scenario1/p68";
import P69 from "../../modules/main/game/scenario1/p69";
import P70 from "../../modules/main/game/scenario1/p70";
// import P71 from "../../modules/main/game/scenario1/p71";
import P72 from "../../modules/main/game/scenario1/p72";
import P73 from "../../modules/main/game/scenario1/p73";    
// import P74 from "../../modules/main/game/scenario1/p74";
import P75 from "../../modules/main/game/scenario1/p75";
import P76 from "../../modules/main/game/scenario1/p76";
import P77 from "../../modules/main/game/scenario1/p77";
import P78 from "../../modules/main/game/scenario1/p78";
import P79 from "../../modules/main/game/scenario1/p79";
import P80 from "../../modules/main/game/scenario1/p80";
import P81 from "../../modules/main/game/scenario1/p81";
import P82 from "../../modules/main/game/scenario1/p82";
import P83 from "../../modules/main/game/scenario1/p83";
import P84 from "../../modules/main/game/scenario1/p84";
import P85 from "../../modules/main/game/scenario1/p85";
import P86 from "../../modules/main/game/scenario1/p86";
import P87 from "../../modules/main/game/scenario1/p87";
import P88 from "../../modules/main/game/scenario1/p88";
import { PAGES } from "..";
import ScrollToMe from "@mborecki/react-scroll-to-me";

type Props = {
    id: string,
}

type PageInfo = {
    id: string,
    page: React.FC,
}

const Index: PageInfo[] = [{
    id: PAGES.p1,
    page: P1
},
    {
        id: PAGES.p2,
        page: P2
    },{
        id  : PAGES.p3,
        page: P3
    },{
        id  : PAGES.p4,
        page: P4
    },{
        id  : PAGES.p5,
        page: P5
    },{
        id  : PAGES.p6,
        page: P6
    },{
        id  : PAGES.p7,
        page: P7
    },{
        id  : PAGES.p8,
        page: P8
    },{
        id  : PAGES.p9,
        page: P9
    },{
        id  : PAGES.p10,
        page: P10
    },{
        id  : PAGES.p11,
        page: P11
    },{
        id  : PAGES.p12,
        page: P12
    },{
        id  : PAGES.p13,
        page: P13
    },{
        id  : PAGES.p14,    
        page: P14
    },{
        id  : PAGES.p15,        
        page: P15
    },{
        id  : PAGES.p16,        
        page: P16        
    },{
        id  : PAGES.p17,        
        page: P17        
    },{
        id  : PAGES.p18,        
        page: P18        
    },{
        id  : PAGES.p19,        
        page: P19        
    },{
        id  : PAGES.p20,        
        page: P20        
    },{
        id  : PAGES.p21,        
        page: P21        
    },{
        id  : PAGES.p22,        
        page: P22        
    },{
        id  : PAGES.p23,        
        page: P23        
    },{
        id  : PAGES.p24,        
        page: P24        
    },{
        id  : PAGES.p25,        
        page: P25        
    },{
        id  : PAGES.p26,        
        page: P26        
    },{
        id  : PAGES.p27,        
        page: P27        
    },{
        id  : PAGES.p28,        
        page: P28        
    },{
        id  : PAGES.p29,        
        page: P29        
    },{
        id  : PAGES.p30,        
        page: P30        
    },{
        id  : PAGES.p31,        
        page: P31        
    },{
        id  : PAGES.p32,        
        page: P32        
    },{
        id  : PAGES.p33,        
        page: P33        
    },{
        id  : PAGES.p34,        
        page: P34        
    },{
        id  : PAGES.p35,        
        page: P35        
    },{
        id  : PAGES.p36,        
        page: P36        
    },{
        id  : PAGES.p37,        
        page: P37        
    },{
        id  : PAGES.p38,        
        page: P38
    },
    {
        id  : PAGES.p39,        
        page: P39
    },
    {
        id  : PAGES.p40,        
        page: P40
    },
    {
        id  : PAGES.p41,        
        page: P41
    },
    {
        id  : PAGES.p42,        
        page: P42
    },
    {
        id  : PAGES.p43,        
        page: P43
    },
    {
        id  : PAGES.p44,        
        page: P44
    },
    {
        id  : PAGES.p45,        
        page: P45
    },
    {
        id  : PAGES.p46,        
        page: P46
    },
    {
        id  : PAGES.p47,        
        page: P47
    },
    {
        id  : PAGES.p48,        
        page: P48
    },
    {
        id  : PAGES.p49,        
        page: P49
    },
    {
        id  : PAGES.p50,        
        page: P50
    },
    {
        id  : PAGES.p51,        
        page: P51
    },
    {
        id  : PAGES.p52,        
        page: P52
    },
    {
        id  : PAGES.p53,        
        page: P53
    },
    {
        id  : PAGES.p54,        
        page: P54
    },
    {
        id  : PAGES.p55,        
        page: P55
    },
    {
        id  : PAGES.p56,        
        page: P56
    },
    {
        id  : PAGES.p57,        
        page: P57
    },
    {
        id  : PAGES.p58,        
        page: P58
    },
    {
        id  : PAGES.p59,        
        page: P59
    },
    {
        id  : PAGES.p60,        
        page: P60
    },
    {
        id  : PAGES.p61,        
        page: P61
    },
    {
        id  : PAGES.p62,        
        page: P62
    },
    {
        id  : PAGES.p63,        
        page: P63
    },
    {
        id  : PAGES.p64,        
        page: P64
    },
    {
        id  : PAGES.p65,        
        page: P65
    },
    {
        id  : PAGES.p66,        
        page: P66
    },
    {
        id  : PAGES.p67,        
        page: P67
    },
    {
        id  : PAGES.p68,        
        page: P68
    },
    {
        id  : PAGES.p69,        
        page: P69
    },
    {
        id  : PAGES.p70,        
        page: P70
    },    
    // {
    //     id  : PAGES.p71,        
    //     page: P71
    // },
    {
        id  : PAGES.p72,        
        page: P72
    },
    {
        id  : PAGES.p73,        
        page: P73
    },
    // {
    //     id  : PAGES.p74,        
    //     page: P74
    // },
    {
        id  : PAGES.p75,        
        page: P75
    },
    {
        id  : PAGES.p76,        
        page: P76
    },
    {
        id  : PAGES.p77,        
        page: P77
    },
    {
        id  : PAGES.p78,        
        page: P78
    },
    {
        id  : PAGES.p79,        
        page: P79
    },
    {
        id  : PAGES.p80,        
        page: P80
    },
    {
        id  : PAGES.p81,        
        page: P81
    },
    {
        id  : PAGES.p82,        
        page: P82
    },
    {
        id  : PAGES.p83,        
        page: P83
    },
    {
        id  : PAGES.p84,        
        page: P84
    },
    {
        id  : PAGES.p85,        
        page: P85
    },
    {
        id  : PAGES.p86,        
        page: P86
    },
    {
        id  : PAGES.p87,        
        page: P87
    },
    {
        id  : PAGES.p88,        
        page: P88
    },
]
export default function GamePage({ id }: Props) {
    const dispatch = useMainModuleDispatch();
    const Page = useMemo(() => {
        const infoIndex = Index.findIndex(p => p.id === id);
        const info = Index[infoIndex];
        dispatch({
            type: MAIN_MODULE_ACTION.SET_GAME_PROGRESS,
            payload: {
                progress: Math.min(100, infoIndex / (Index.length - 2))
            }
        })
        if (info) {
            return info.page;
        }

        return () => <p>Nieznana strona!</p>
    }, [id, dispatch])

    return <>
        <ScrollToMe trigger={id} behavior="smooth" />
        <Page />
    </>
}